<template>
    <div class="pmtdiv">
        <smallbutton :toplabel="name" @click="start()" v-if="showButton" :buttonclass="buttonClass"/>
        <linkbutton :toplabel="name" @click="start()" v-if="!showButton"/>
        <!--  MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form ref="balform">
                    
                    <label class="titlelabel">{{name}}</label>
                    <br/>
                    <br/>
                    <smallbutton toplabel="Print Reservations"  @click="printReservations"  />
                    <div class="horizFlexCenter margin10">
                     
                        <select name="" id="" class='seltype' v-model="seatingId"  @change="gettickets">
                            <option v-for="s in seatingList" :key="s.id" :value="s.id" >
                                {{s.name}}
                            </option>
                        </select>
                    </div>

                    
                    <br/>
                    

                    <label class="seatingmessage">{{ seatingMessage }}</label>
                    <updatereservation :isNew="trueParam" :seating="seating" :businessDayId="businessDayId" :terminalId="terminalId" v-if="allowNewReservation" @refresh="gettickets"/>

                    
                    <div>
                        <label v-if="ticketList.length==0 && seating!=null">There are no reservations</label>
                    </div>
                    <div class="scrollbox2">
                        <div :class="ticketclass(t)" v-for="t in ticketList" :key="t.id" :value="t.id" >
                            <div class="ticketrecordreserve">
                               
                                <label class="linkdiv " for>{{t.guestName}} ({{ t.guestCount }} guests)</label>
                                
                                <div class="horizFlex rightjustify ">
                                    <div class="linkdiv">
                                        <confirm :showLink="trueParam" title="Arrived" body="Have your guests arrived?" @yes="reservationArrived(t)"/>
                                    </div>
                                    <div class="linkdiv">
                                        <updatereservation :isNew="falseParam" :seating="seating" :businessDayId="businessDayId"  @refresh="gettickets" :reservationTicket="t"/>
                                    </div>
                                    
                                    <div class="linkdiv">
                                        <confirm :showLink="trueParam" title="Cancel" body="Do you want to cancel this reservation?" @yes="cancelReservation(t)"/>
                                    </div>
                                    
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                    
                    <!-- print -->
                     <div class="">
                        <div class="forprint" id="resforprint">
                            <div class="horizFlexCenter">
                                <label class="seatingmessage">{{ seating.name }}</label>
                            </div>
                            <div class="horizFlexCenter">
                                <label class="seatingmessage">{{ timeNow }}</label>
                            </div>
                            <div :class="ticketclass(t)" v-for="t in ticketList" :key="t.id" :value="t.id" >
                                <div class="resdetails">
                                <input type="checkbox" class="rescheck"/>
                                    <label class="linkdiv " for>{{t.guestName}} ({{ t.guestCount }} guests) </label>
    
                                    <label class="linkdiv " for> {{ formatPhoneres(t.guestPhone) }}</label>
                                </div>
                                
                            </div>
                        </div>
                     </div>
                    
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
                    
                    
                </form>
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import datamethods from '../../services/datamethods.js'
    import confirm from '../actions/confirm.vue'
    import updatereservation from './updatereservation.vue'
    import pos from '../../services/pos.js'
    import pos_culinary from '../../services/pos_culinary.js'
import Updatereservation from './updatereservation.vue'
    export default {
        name:'reservations',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton,
            confirm,
            updatereservation
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },
            name:{
                type:String,
                default:"Reservations"
            },
            defaultAmount:{
                type:Number,
            },
            numberDataLabel:{
                type:String,
                default:''
            },
            buttonClass:{
                type:String,
                default:'button buttonprimary bottom10'
            }
            
        },
        mixins:[format, datamethods,pos,pos_culinary],
        directives:{
            print
        },
        data(){
            return{
                ticketList:[],
                ticketId:0,
                trueParam:true, 
                filterType:null,
                filterDate:null,
                types:[],
                seatingList:[],
                seatingId:0,
                seating:null,
                seatingMessage:null,
                falseParam:false
            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait',
                'location',
                'businessDayId',
                'terminalId'
     
            ]),
            allowNewReservation(){
                if(this.seating==null) {return false}
                if(this.seating.seatsAvailable<=0){return false}
                return true
            },
            timeNow(){
                return 'Printed: ' + this.$options.filters.formatTime_Now()
            }
            
        },
        methods:{
            formatPhoneres(phn) {
                console.log('formatph ' + phn)
                if(phn==null){return ''}
                if(phn==''){return ''}
                phn=phn.replace('-','').replace('(','').replace(')','').replace(' ','')
                
                phn=phn.replace('.','')
                phn=phn.replace('.','')
                //console.log('cleannum ' + phn)
                if(phn.length==11 && phn.substring(0,1)=='1'){phn=phn.substring(1)}
        
                phn = "(" + phn.substring(0,3) + ")" + phn.substring(3,6) + "-" + phn.substring(6);
                return phn
                    
            },
            async cancelReservation(t){
                //call api
                let req = {
                    ticket:t
                }

                    this.$store.dispatch('beforeAPI');
                    var response = await this.callAPI(req,'ticket_cancelreservation')
                    //handle response
                
                    if(response.Successful){
                        this.gettickets()
                    }else{
                    this.responseMessage = response.Message
                    }
                    this.pleaseWait=false;
            },
            async reservationArrived(t){
                await this.seatTicket(t,false)//the false is so it doesn't clear/start over ticket
                this.gototicket(t.id,true)//the true is to tell it to go to the guest tab!
                        this.$refs.mymodal.closeModal()
                //call api
                /* let req = {
                    ticket:t
                }

                    this.$store.dispatch('beforeAPI');
                    var response = await this.callAPI(req,'suspendticket')
                    //handle response
                
                    if(response.Successful){
                        this.gototicket(t.id,true)//the true is to tell it to go to the guest tab!
                        this.$refs.mymodal.closeModal()
                    }else{
                    this.responseMessage = response.Message
                    }
                    this.pleaseWait=false; */
            },
            async getTypes(){
             
                    //call api
                    this.$store.dispatch('beforeAPI');
                    var response = await this.callAPI(null,'seatingtypes')
                    //handle response
                
                    if(response.Successful){
                        this.types=response.SeatingTypeList
                        if(this.types.length>0){
                            this.filterType=this.types[0].id
                        }
                    }else{
                    this.responseMessage = response.Message
                    }
                    this.pleaseWait=false;
            },
            
            ticketclass(g){
                let c = "guestdetails panel-inner  color-inner"
                /* if(g.id==this.ticketId){
                    c=c+" color-highlight"
                }else{c=c+" color-inner"} */
                return c
            },
            selectTicket(id){
                console.log('sel ' + id)
                this.ticketId=id
            },
            async start(){
                if(this.types.length==0){
                    await this.getTypes() 
                }

                await this.getSeatingList()

                if(this.filterType==null){
                    if(this.types.length>0){
                            this.filterType=this.types[0].id
                        }
                }
                this.filterDate=this.$options.filters.formatDateForInputToday()
                this.gettickets()
    
            },
            async gettickets(){
                this.getSeating()

                var req
                if(this.seatingId>0){
                    req = {
                        seatingId:this.seatingId
                    }
                }else{
                    req = {
                        seatingTypeId:this.filterType,
                        seatingDate:this.filterDate
                    }
                }
                 
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'ticketlist_reservations')
                //handle response
            
                if(response.Successful){
                    this.ticketList=response.ticketList
                    this.$refs.mymodal.openModal()
                    if(this.ticketList.length>0){
                        this.selectTicket(this.ticketList[this.ticketList.length-1].id)
                    }
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            },
             async getSeating(){
                

                var req
                if(this.seatingId>0){
                    req = {
                        seatingId:this.seatingId
                    }
                }else{
                    req = {
                        seatingTypeId:this.filterType,
                        seatingDate:this.filterDate
                    }
                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'seating')
                //handle response
            
                if(response.Successful){
                    this.seating=response.Seating
                    console.log('seating ' + this.seating)
                    if(this.seating==null){
                        this.seatingMessage="The date and seating selected is not available for reservations."
                    }else{
                        this.seatingMessage="There are " + this.seating.seatsAvailable + " seats available"
                    }
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            },
            async getSeatingList(){
                

                let req = {
                    seatingTypeId:null,
                    seatingDate:null,

                }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'seatinglist')
                //handle response
            
                if(response.Successful){
                    this.seatingList = response.SeatingList
                    if(this.seatingList.length>0){
                        this.seatingId=this.seatingList[0].id
                    }
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;
                        
            },
            printReservations(){
                
                window.print()
              
                /* console.log('print res new page')
                var mywindow = window.open('', 'PRINT', 'height=650,width=600');
        
                mywindow.document.write('<html><head><title>' + 'reservations'  + '</title>');
                mywindow.document.write('<style>body{white-space:pre-wrap;}</style>');
                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById('resforprint').innerHTML);
                mywindow.document.write('</body></html>');
        
                mywindow.document.close(); // necessary for IE >= 10 */
                },
        },
async mounted(){
    

    
}
    }
    
    </script>
    
    <style>
    @media print {
        body * {
            visibility: hidden;
        }

        #resforprint, #resforprint * {
            visibility: visible;
        }

        #resforprint {
            position: absolute;
            left: 0;
            top: 0;
        }
    }

  @media screen {
    #resforprint {
        display: none;
    }
}
    .rescheck{
        margin:0px;
        height:20px;
        align-self:left;
    }
    .ticketfield{
        min-width:100px;
    }
    .ticketrecordreserve{
        width:100%;
        display:grid;
        grid-template-columns: 2fr   1fr;
        text-align: left;
    }
    .leftjustify{
        text-align: left;
    }
    .rightjustify{
        text-align: right;
    }

.scrollbox2{
  height:550px;
  overflow-y: scroll;
  overflow-x:hidden;
}
.seltype{
    font-size:inherit;
    height:25px;
    margin-left:5px;
    width:200px;
}
.seldate{
    width:110px;
    height:21px;
}
.linkdiv{
    padding:3px 8px 3px 8px;
}
.seatingmessage{
    font-weight: bold;
    font-size: larger;
}
.resdetails {
 display:grid;
 grid-template-columns: 30px 2fr 1fr;
 text-align: left;
}
.forprint{
    width:100%;
}
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    